<template>
  <div class="card shadow" >
    <div class="card-header border-0" >

      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0">
            POS Tracking Version
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <vuetable
        v-if="apiURL"
        ref="vuetable"
        :api-url="apiURL"
        :http-options="httpOptions"
        :fields="fields"
        :sort-order="sortOrder"
        :show-sort-icons="true"
        :per-page="10"
        :css="css.table"
        pagination-path=""
        data-path="data"
        no-data-template="Empty"
        @vuetable:load-error="onLoadError"
        @vuetable:pagination-data="onPaginationData">
      </vuetable>

      <div v-else class="col-md-12">
        <center>
          <h5 class="navbar-heading text-muted">Please select an account for viewing.</h5>
        </center>
        <br/>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage';


export default {
  name: 'pos-tracking-version',
  props: {
    accountId: Number,
    terminalId: Number,
    siteId: Number,
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
  },
  data() {
    return {
      apiURL: "",
      filterStatus: "",
      fields: [
        {name: "terminal_id", title: "Terminal ID"},
        {name: "terminal_name", title: "Name"},
        {name: "terminal_code", title: "Code"},
        {name: "site_name", title: "Site Name"},
        {name: "version", title: "Version"},
        {name: "operating_system", title: "Operating System"},
        {name: "status", title: "Status"}
      ],
      sortOrder: [{ field: "name", direction: "asc" }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      }
    }
  },
  mounted: function () {
    let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
    this.apiURL = `${this.endPoint}terminals/pos_tracking_version${params}&site_id=${this.siteId}&terminal_id=${this.terminalId}`;
  },
  watch: {
    accountId: async function() {
      let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
      this.apiURL = `${this.endPoint}terminals/pos_tracking_version${params}&site_id=${this.siteId}&terminal_id=${this.terminalId}`;
      this.$refs.vuetable.resetData();
    },
    parameters: function () {
      let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
      this.apiURL = `${this.endPoint}terminals/pos_tracking_version${params}`;
      this.$refs.vuetable.selectedTo = []
      // this.checkedItems = []
    }
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo
    },
    async onLoadError(error) {
      console.log(error)
    },
  }
}
</script>
